import styled from 'styled-components/macro';
import { PreviewRow } from '../../../../feature/arrearsDecisions';

const money = (n: number) => `£${n.toFixed(2)}`;
const fmt = (iso: string) => new Date(`${iso}T00:00:00Z`).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' });

export default function SchedulePreviewTable({ rows }: { rows: PreviewRow[] }) {
  return (
    <Table>
      <thead>
        <tr><th>Collection date</th><th>Extra (recovery)</th><th>Usual collection</th><th>Parent pays that month</th></tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.date}>
            <td>{fmt(r.date)}</td>
            <td>{money(r.extra)}</td>
            <td>{r.usual ? money(r.usual) : '—'}</td>
            <td><strong>{money(r.total)}</strong></td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  th, td { text-align: left; padding: 8px 10px; border-bottom: 1px solid #E0E0E0; }
  th { color: #6B7A87; font-weight: 600; }
`;
